// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/field/PageHeader.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/field/PageHeader.tsx");
  import.meta.hot.lastModified = "1740183864613.1895";
}
// REMIX HMR END

import React from "react";
import ContentWrapper from "~/components/ContentWrapper";
import Heading from "../Heading";
export default function PageHeader({
  children,
  title
}) {
  return <ContentWrapper Item="header" spacing="primary" className="flex-col items-center text-neutral-100 bg-gradient-primary animate-background-transition bg-400% pt-[57px] md:pt-[120px]">
      <div className="w-full max-w-[45ch] mt-14 text-center">
        <Heading tag="h1" className="!text-neutral-100">
          {title}
        </Heading>
      </div>
      {children}
    </ContentWrapper>;
}
_c = PageHeader;
var _c;
$RefreshReg$(_c, "PageHeader");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;